import { Sku } from './Sku';

export class DashboardSkuGroup{
    groupName:String;
    groupSubtitle:String;
    skus: Array<Sku>;
    shortcuts: Array<Sku>;

    constructor({
        group_name = '',
        group_subtitle = '',
        skus = [],
        shortcuts = []
    }){
        this.groupName = group_name;
        this.groupSubtitle = group_subtitle;
        this.skus = skus;
        this.shortcuts = shortcuts
    }
}
